/**
 * 語言資源索引
 * 匯出所有語言資源
 */

import { enResources } from "./en";
import { zhTWResources } from "./zh-TW";
import { LOCALES } from "@/domain/constants/locales";

/**
 * 所有語言資源
 */
export const resources = {
  [LOCALES.EN]: enResources,
  [LOCALES.ZH_TW]: zhTWResources,
} as const;
